import { observer } from "mobx-react-lite";
import { ContextProps, MenuSite } from "@menu/core/types";
import { getAnalyticTags, getChannelImage, getDataTitleTag } from "@menu/core/lib";
import { useOpenLink } from "@menu/core/hooks";

type ChannelsListProps = ContextProps & {
    className: string
}

const ChannelsList = observer((props: ChannelsListProps) => {
    const { className, context } = props;
    const channels = context.channels;
    const openLink = useOpenLink(context);

    const getTags = (site: MenuSite) => {
        return getAnalyticTags({
            component_name: "site_switcher",
            nav_item: site.title,
            nav_text: `${site.title}_logo`,
            target_page_url: site.link
        });
    }

    return (<ul className={className}>
        {channels.map((x, ix) =>
            <li key={ix}
                {...getDataTitleTag(x.title)}
                {...getTags(x)}
                onClick={(e) => openLink(e, x, context)}>
                <img src={getChannelImage(x)} alt={x.title} />
            </li>)}
    </ul>);
});

export default ChannelsList;